import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const highlights = [
    {
        icon: 'fas fa-arrows-rotate',
        title: 'Digitalizzazione dei processi',
        text: 'Da fogli di calcolo e carta a flussi di lavoro digitali, integrati con il tuo gestionale.'
    },
    {
        icon: 'fas fa-gears',
        title: 'Automazione che lavora per te',
        text: 'Ordini, fatture e magazzino si muovono da soli: eliminiamo le attività ripetitive e gli errori manuali.'
    },
    {
        icon: 'fas fa-chart-line',
        title: 'Decisioni guidate dai dati',
        text: 'Report e dashboard in tempo reale per governare l\u2019azienda con i numeri, non con le sensazioni.'
    }
];

function ConsulenzaSection() {
    return (
        <section id="consulenza" className="consulenza-section section-padding">
            <Container>
                <Row className="align-items-center">
                    <Col lg={6} className="mb-5 mb-lg-0">
                        <div className="fade-in-up">
                            <h2 className="section-title">
                                Consulenza e <span className="gradient-text">Digital Transformation</span>
                            </h2>
                            <p className="about-text">
                                La digitalizzazione non è un prodotto da comprare, ma un percorso da costruire.
                                Analizziamo come lavora la tua azienda, individuiamo sprechi e colli di bottiglia
                                e li trasformiamo in processi digitali semplici e automatizzati.
                            </p>
                            <p className="about-text">
                                Meno carta, meno errori, meno tempo perso: più spazio per far crescere il tuo business.
                            </p>
                            <Link to="/digital-transformation" className="btn-gradient">
                                <span>Scopri la Digital Transformation</span>
                            </Link>
                        </div>
                    </Col>
                    <Col lg={6}>
                        {highlights.map((item, index) => (
                            <div key={index} className="process-item fade-in-up" style={{animationDelay: `${index * 0.2}s`}}>
                                <div className="process-content">
                                    <div className="process-icon"><i className={item.icon}></i></div>
                                    <div className="process-text">
                                        <h4 className="process-title">{item.title}</h4>
                                        <p className="process-description">{item.text}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default ConsulenzaSection;
